/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TituloEmpleoEstadoIdJobTitlePatch$Params {
  Accept?: string;
  idJobTitle: string;
      body?: {
}
}

export function tituloEmpleoEstadoIdJobTitlePatch(http: HttpClient, rootUrl: string, params: TituloEmpleoEstadoIdJobTitlePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, tituloEmpleoEstadoIdJobTitlePatch.PATH, 'patch');
  if (params) {
    rb.header('Accept', params.Accept, {});
    rb.path('idJobTitle', params.idJobTitle, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

tituloEmpleoEstadoIdJobTitlePatch.PATH = '/titulo-empleo/estado/{idJobTitle}';
